__turbopack_context__.v({
  "likeCount": "_8jeyhq_likeCount",
  "linkContainer": "_8jeyhq_linkContainer",
});
